import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	margin: 30px;
	flex-direction: column;
	min-width: 98%;
	max-height: calc(100vh - 150px);
	align-items: center;
	gap: 30px;
	overflow-y: auto;
`;